import { forwardRef } from 'react';
import type Scrollbars from 'react-custom-scrollbars-2';

import classNames from 'classnames';
import { ScrollView, type ScrollViewProps } from './ScrollView';

/**
 * Shortcut for <ScrollView> with flex column both inner and outer layout
 *
 * @see ScrollView
 */
export const ScrollColumnView = forwardRef<Scrollbars, ScrollViewProps>(
  ({ className, contentClassName, ...otherProps }, ref) => (
    <ScrollView
      {...otherProps}
      ref={ref}
      className={classNames('flex flex-1 flex-col', className)}
      contentClassName={classNames('flex flex-1 flex-col', contentClassName)}
    />
  ),
);

ScrollColumnView.displayName = 'ScrollView';
